import React from "react";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { motion } from "framer-motion";

import gymImage from "../../static/media/Home/gym.webp";

const PRIMARY = "#06BBC7";
const DARK_PRIMARY = "#047b84";
const YELLOW = "#F7C948";
const YELLOW_HOVER = "#efbd35";
const PARTNER_RED = "#E11D2E";
const TEXT = "#1f2937";

const MotionBox = motion(Box);
const MotionButton = motion(Button);

const BodySculptPremium = () => {
  const benefits = [
    "Moldea tu figura",
    "Activa tu cuerpo",
    "Potencia tus resultados",
  ];

  const whatsappMessage =
    "Hola, vengo desde la sección BODY SCULPT PREMIUM – RETO 90 DÍAS de Lily's Sunflower. Quiero recibir más información sobre la alianza con NOVAXFIT Gym Center.";

  const whatsappUrl = `https://wa.me/593984781610?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 5, md: 8 },
        bgcolor: "#ffffff",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            alignItems: "center",
            gap: { xs: 4, md: 7 },
          }}
        >
          <MotionBox
            initial={{ opacity: 0, x: -28 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            sx={{
              textAlign: { xs: "center", md: "left" },
              order: { xs: 2, md: 1 },
            }}
          >
            <Typography
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "rgba(225, 29, 46, 0.08)",
                color: PARTNER_RED,
                border: "1px solid rgba(225, 29, 46, 0.18)",
                px: 2,
                py: 0.75,
                borderRadius: "999px",
                fontSize: "0.78rem",
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                mb: 2.2,
              }}
            >
              Alianza exclusiva
            </Typography>

            <Typography
              component="h2"
              sx={{
                fontFamily: "'Playfair Display', serif",
                fontSize: { xs: "2.25rem", sm: "2.85rem", md: "3.55rem" },
                fontWeight: 500,
                lineHeight: 1.04,
                letterSpacing: "-0.04em",
                color: TEXT,
                mb: 1.2,
              }}
            >
              BODY SCULPT PREMIUM
            </Typography>

            <Typography
              component="h3"
              sx={{
                color: PARTNER_RED,
                fontSize: { xs: "1.05rem", md: "1.22rem" },
                fontWeight: 800,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                mb: 2.4,
              }}
            >
              Reto 90 días
            </Typography>

            <Typography
              sx={{
                maxWidth: 620,
                mx: { xs: "auto", md: 0 },
                color: "rgba(31, 41, 55, 0.84)",
                fontSize: { xs: "0.98rem", md: "1.08rem" },
                lineHeight: 1.75,
                fontWeight: 400,
                mb: 2,
              }}
            >
              Una alianza exclusiva entre Lily&apos;s Sunflower Centro Estético
              Integral y NOVAXFIT Gym Center para ayudarte a transformar tu
              cuerpo de forma integral.
            </Typography>

            <Typography
              sx={{
                maxWidth: 620,
                mx: { xs: "auto", md: 0 },
                color: "rgba(31, 41, 55, 0.76)",
                fontSize: { xs: "0.95rem", md: "1.02rem" },
                lineHeight: 1.75,
                fontWeight: 400,
                mb: 3,
              }}
            >
              Combina tratamientos estéticos corporales, aparatología
              especializada, seguimiento personalizado y acceso al gimnasio para
              potenciar tus resultados.
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
                gap: 1.2,
                maxWidth: 680,
                mx: { xs: "auto", md: 0 },
                mb: 3,
              }}
            >
              {benefits.map((item, index) => (
                <MotionBox
                  key={item}
                  initial={{ opacity: 0, y: 14 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.25 }}
                  transition={{
                    duration: 0.38,
                    delay: index * 0.06,
                    ease: "easeOut",
                  }}
                  sx={{
                    bgcolor:
                      index === 1
                        ? "rgba(225, 29, 46, 0.07)"
                        : "rgba(6, 187, 199, 0.08)",
                    border:
                      index === 1
                        ? "1px solid rgba(225, 29, 46, 0.16)"
                        : "1px solid rgba(6, 187, 199, 0.16)",
                    borderRadius: "18px",
                    px: 2,
                    py: 1.4,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    minHeight: 58,
                  }}
                >
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      bgcolor: index === 1 ? PARTNER_RED : PRIMARY,
                      flexShrink: 0,
                    }}
                  />

                  <Typography
                    sx={{
                      color: TEXT,
                      fontSize: { xs: "0.9rem", md: "0.94rem" },
                      fontWeight: 700,
                      lineHeight: 1.35,
                    }}
                  >
                    {item}
                  </Typography>
                </MotionBox>
              ))}
            </Box>

            <Typography
              sx={{
                maxWidth: 610,
                mx: { xs: "auto", md: 0 },
                color: "rgba(31, 41, 55, 0.72)",
                fontSize: { xs: "0.93rem", md: "0.98rem" },
                lineHeight: 1.7,
                fontWeight: 400,
                mb: 3.5,
              }}
            >
              Dirigido a damas y caballeros que buscan mejorar su imagen,
              condición física y bienestar.
            </Typography>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.4}
              justifyContent={{ xs: "center", md: "flex-start" }}
              alignItems={{ xs: "center", sm: "center" }}
            >
              <MotionButton
                component="a"
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.98 }}
                variant="contained"
                sx={{
                  bgcolor: YELLOW,
                  color: TEXT,
                  px: 4,
                  py: 1.18,
                  borderRadius: "999px",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.95rem",
                  boxShadow: "none",
                  width: { xs: "100%", sm: "auto" },
                  maxWidth: { xs: 320, sm: "none" },
                  "&:hover": {
                    bgcolor: YELLOW_HOVER,
                    boxShadow: "none",
                  },
                }}
              >
                Solicitar información
              </MotionButton>

              <MotionButton
                component="a"
                href="https://nova-xfit.com"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.98 }}
                variant="outlined"
                sx={{
                  borderColor: PARTNER_RED,
                  color: PARTNER_RED,
                  px: 3.4,
                  py: 1.12,
                  borderRadius: "999px",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.95rem",
                  boxShadow: "none",
                  width: { xs: "100%", sm: "auto" },
                  maxWidth: { xs: 320, sm: "none" },
                  "&:hover": {
                    borderColor: PARTNER_RED,
                    bgcolor: "rgba(225, 29, 46, 0.07)",
                    boxShadow: "none",
                  },
                }}
              >
                Conocer NOVAXFIT
              </MotionButton>
            </Stack>
          </MotionBox>

          <MotionBox
            initial={{ opacity: 0, x: 28, scale: 0.98 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.65, ease: "easeOut" }}
            sx={{
              order: { xs: 1, md: 2 },
              position: "relative",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: { xs: -22, md: -28 },
                right: { xs: -18, md: -26 },
                width: { xs: 110, md: 150 },
                height: { xs: 110, md: 150 },
                borderRadius: "50%",
                bgcolor: "rgba(225, 29, 46, 0.08)",
                zIndex: 0,
              }}
            />

            <Box
              sx={{
                position: "absolute",
                left: { xs: -20, md: -32 },
                bottom: { xs: -16, md: -30 },
                width: { xs: 120, md: 180 },
                height: { xs: 120, md: 180 },
                borderRadius: "50%",
                bgcolor: "rgba(6, 187, 199, 0.1)",
                zIndex: 0,
              }}
            />

            <MotionBox
              whileHover={{ y: -4 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
              sx={{
                position: "relative",
                zIndex: 1,
                borderRadius: { xs: "26px", md: "34px" },
                overflow: "hidden",
                bgcolor: "#ffffff",
                border: "1px solid rgba(6, 187, 199, 0.16)",
                p: { xs: 1.4, md: 1.8 },
              }}
            >
              <Box
                component="img"
                src={gymImage}
                alt="NOVAXFIT Gym Center alianza Body Sculpt Premium"
                loading="lazy"
                sx={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                  objectPosition: "center",
                  display: "block",
                  borderRadius: { xs: "20px", md: "28px" },
                }}
              />
            </MotionBox>

            <MotionBox
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.55, delay: 0.16, ease: "easeOut" }}
              sx={{
                mt: 2,
                mx: { xs: "auto", md: 0 },
                maxWidth: 520,
                bgcolor: "rgba(6, 187, 199, 0.08)",
                border: "1px solid rgba(6, 187, 199, 0.16)",
                borderRadius: "22px",
                px: { xs: 2.2, md: 2.6 },
                py: { xs: 2, md: 2.2 },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <Typography
                sx={{
                  color: PARTNER_RED,
                  fontWeight: 800,
                  fontSize: "0.78rem",
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  mb: 0.7,
                }}
              >
                Lily&apos;s Sunflower + NOVAXFIT
              </Typography>

              <Typography
                sx={{
                  color: TEXT,
                  fontWeight: 500,
                  fontSize: { xs: "0.92rem", md: "1rem" },
                  lineHeight: 1.55,
                }}
              >
                Un programa que une estética corporal, entrenamiento y
                seguimiento personalizado para resultados más completos.
              </Typography>
            </MotionBox>
          </MotionBox>
        </Box>
      </Container>
    </Box>
  );
};

export default BodySculptPremium;